<!-- Файл представления компонента главной страницы мобильной версии -->
<div class="cls-home">
    <div class="cls-block">
        <app-block-talons class="app-block-talons"></app-block-talons>
    </div>

    <div class="cls-panels">
        <div
            *ngFor="let panel of panelsMenu; let i = index"
            class="cls-panel-menu"
            [routerLink]="panel.url"
        >
            <div class="img-wrapper">
                <img class="panel__image" [src]="panel.img" alt="panel-img" />
            </div>
            <span class="panel__text">{{ panel.name }}</span>
        </div>
    </div>
    <!-- <div class="footer"></div> -->
</div>
